'use client';
import { ChainLinkBanner } from './ChainLinkBanner/ChainLinkBanner';
import { GetTokensButtons } from './GetTokensButtons/GetTokensButtons';
import { MagicRaffleCard } from './MagicRaffleCard/MagicRaffleCard';
import { NextDrawCounter } from './NextDrawCounter/NextDrawCounter';

export const MagicRaffleWidget = () => {
  return (
    <div className="w-full flex flex-col items-center gap-6 max-md-msq:gap-5">
      <NextDrawCounter />
      <div className="flex flex-col items-center gap-6">
        <MagicRaffleCard />
        <GetTokensButtons />
        <ChainLinkBanner />
      </div>
    </div>
  );
};
